import React from "react";

import withSessionHandling, {
  type SessionHandlerProps,
} from "@/context/auth/withSessionHandling";
import ManageBlockedUsersScreen from "@/screens/Settings/Security/ManageBlockedUsersScreen";

function Page(props: SessionHandlerProps): React.JSX.Element {
  return <ManageBlockedUsersScreen {...props} />;
}

export default withSessionHandling(Page);
